<template>
  <v-autocomplete :items="items" v-bind="$props" v-model="model"
                  clearable dense
  ></v-autocomplete>
</template>

<script>
import routeC from '@/data/route_c.json'
import routeD1 from '@/data/route_d1.json'
import routeD2 from '@/data/route_d2.json'
import _ from "lodash";

export default {
  name: "CustomRoute",
  props: {
    type: {type: String, required: true, default: "C"},
    value: {type: String, default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true}
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.on.input(v)
      }
    },
    items() {
      switch (this.type) {
        case "C":
          return this.routeCItems
        case "D1":
          return this.routeD1Items
        case "D2":
          return this.routeD2Items
        default:
          return []
      }
    },
    routeCItems() {
      // let curPref;
      let routeItems =  routeC.flatMap((v) => {
        let v1 = v["申請機関名"], v2 = v["養成課程等の名称"], v3 = v["実施期間"], v4=v["都道府県"]
        if (v1 === "申請機関名") return;
        return this.createRouteItems(v1,v2,v3,v4)
        // if(curPref !== v4){
        //   ret.unshift({divider: v4, header: v4})
        // }
        // curPref = v4
        // return ret
      });
      routeItems.unshift({
        text: "下記以外の機関等", value:"下記以外の機関等"
      })
      return routeItems
    },
    routeD1Items() {
      let routeItems = routeD1.flatMap((v) => {
        let v1 = v["申請機関名"], v2 = v["養成課程等の名称"], v3 = v["実施期間"]
        if (v1 === "申請機関名") return;
        return this.createRouteItems(v1,v2,v3);
      });
      routeItems.unshift({
        text: "下記以外の機関等", value:"下記以外の機関等"
      })
      return routeItems
    },
    routeD2Items() {
      let routeItems =  routeD2.flatMap((v) => {
        let v1 = v["養成機関・団体名"], v2 = v["研修名"], v3 = v["時間数"]
        if (v1 === "養成機関・団体名") return;
        return this.createRouteItems(v1,v2,v3);
      })
      routeItems.unshift({
        text: "下記以外の機関等", value:"下記以外の機関等"
      })
      return routeItems
    },
  },
  methods: {
    createRouteItems(v1, v2, v3, prepend) {
      let ret = [], v2a = _.split(v2, "\n"), v3a = _.split(v3, "\n")
      let v3base = v3a[0]
      let pre = prepend ? prepend+" " : ""
      for (let i in v2a) {
        let v3dips = v3a[i] || v3base
        let value = `${v1} ${v2a[i]} ${v3dips}`
        let text = `${pre}${v1}\n${v2a[i]}\n${v3dips}`
        ret.push({value, text})
      }
      return ret
    }
  }
}
</script>

<style scoped>
* /deep/ .v-list-item__title {
  white-space: pre-wrap;
}
</style>
